import Calculator from './components/Calculator/Calculator';
import './App.scss'

function App() {
  return (
    <div className="App">
      <h1 className='logo'>SPLI</h1>
      <h1 className='logo'>TTER</h1>
      <Calculator />
    </div>
  );
}

export default App;
